import React, { useRef } from "react";
import { NumericFormat } from "react-number-format";
import { ReactComponent as IncumbentIcon } from "../images/icon-incumbent.svg";
import { getOverride } from "../helpers";
import placeholder from '../images/placeholder.jpg';

const Race = ({
  result,
  shouldShowImages,
  thereIsAWinner,
  options,
  votesCast
}) => {
  const raceCandidates = useRef(null);
  const candidates = result
    .map((candidate, index) => {
      const name = getOverride(candidate, "name");
      const votes = getOverride(candidate, "votes");
      const incumbent = getOverride(candidate, "incumbent");
      const winner = getOverride(candidate, "winner");
      const party = (options.showParty && getOverride(candidate, "party")) || "";

      var decodedName = name.replace(/&quot;/g, '"');
      decodedName = decodedName.replace(/&amp;/g, '&');
      // We are ALWAYS calculating the percentage field unless there's an overwrite
      const percentOfVotes =
        candidate.percentage_override || (votesCast > 0 ? ((votes / votesCast) * 100) : 0);

      return (
        <div
          className={
            "grid-row" +
            (shouldShowImages ? "" : " no-image") +
            (options.showPercentOfVotes && votesCast > 0
              ? ""
              : " no-percentage") +
            (thereIsAWinner && winner ? " winner" : "") +
            (thereIsAWinner && !winner ? " loser" : "")
          }
          key={index}
        >
          <div className="latest-progressBar">
          {shouldShowImages && (
            <div className="race-image">
              <figure>
                <img src={candidate.image ? candidate.image : placeholder} alt="placeholder" />
              </figure>
            </div>
          )}
          <div className="race-info">
            <div className="race-name-container">
              {incumbent ? <div className="race-incumbent">
                {(
                  <IncumbentIcon alt="Incumbent" className="incumbent-icon" />
                )}
              </div> : '' }
              <div className={`race-name ${incumbent ? 'incumbent' : ''}`}>{decodedName}</div>
            </div>
            {party && options.showParty && (
                <div className="race-party">{party}</div>
              )}
            </div>
          <div className="race-votes">
            {options.showVotes && (
                <div>
                  <NumericFormat
                    value={votes}
                    displayType={"text"}
                    thousandSeparator={true}
                  />{" "}
                  votes
                </div>
            )}
            {options.showPercentOfVotes && (
              <div className="race-percentage progress-bar-percentage">{options.showPercentOfVotesDecimal ? percentOfVotes.toFixed(1) : percentOfVotes.toFixed(0)}%</div>
            )}
            </div>
           </div>
           {options.showPercentOfVotes && (
            <div className="indicator race-votes-percentage progress-bar-and-percentage-container">
              <div className="progress-wrapper">
                <progress
                    className={(party && party.toLowerCase()) + " progress-bar-with-percentage"} // Doesn't use override.
                    max={votesCast}
                    value={votes}
                  />
              </div>
            </div>
           )}
        </div>
      );
    });

  return (
      <div className="race-candidates" ref={raceCandidates}>
        {candidates}
      </div>
  );
};

export default Race;
